import { motion } from 'motion/react';
import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { Header } from './Header';
import { Sidebar } from './Sidebar';

export function AppShell() {
  const location = useLocation();

  // Scroll to top on route change.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="grid min-h-screen grid-rows-[auto_1fr] text-ugin-text">
      <Header />
      <div className="grid grid-cols-1 md:grid-cols-[240px_minmax(0,1fr)]">
        <Sidebar />
        <main
          id="main-content"
          tabIndex={-1}
          className="px-4 py-6 md:px-8 md:py-10 max-w-[1600px] w-full mx-auto"
        >
          <motion.div
            key={location.pathname}
            initial={{ opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.18, ease: [0.16, 1, 0.3, 1] }}
          >
            <Outlet />
          </motion.div>
        </main>
      </div>
    </div>
  );
}
